import { filter, pipe, takeUntil, toArray } from '@fxts/core';

export const isFormModified = <T extends string[] = string[]>({
  parent,
  names,
  initial,
  hook,
}: {
  parent: HTMLElement;
  names: T;
  initial: Record<string, any>;
  hook?: Record<T[0], (k: string) => string>;
}) => {
  const modified_els = pipe(
    parent.querySelectorAll('input'),
    filter((el) => names.includes(el.name)),
    filter((input) => {
      if (input.type === 'checkbox') {
        return input.checked !== initial[input.name];
      } else if (input.type === 'radio') {
        const modified = input.value !== initial[input.name].toString();
        return input.checked === modified;
      } else {
        return (hook?.[input.name] ? hook[input.name](input.value) : input.value) !== initial[input.name];
      }
    }),
    takeUntil((dirty) => dirty),
    toArray,
  );

  return modified_els.length > 0;
};
